import { slugify, IDigitalData } from "@sky-it-livedata-libraries/livedata-commons";

declare global {
    interface Window {
        digitalData: IDigitalData;
    }
}
  

export const handleGalleryTabsNavigation = () => {
    const tabs = document.querySelectorAll('.ftbl__team-tabs-wrapper__tab');

    window.addEventListener("hashchange", (e) => {
        e.preventDefault();
    });

    if(location.hash) {
        navigateTab({tabs});
    }

    tabs?.forEach(element => {
        element.querySelector('input[type="radio"]')?.addEventListener('change', (event: Event) => {
            location.hash = slugify((event?.target as HTMLElement)?.id);
        })
    });
};

const navigateTab = (params: {tabs: NodeListOf<Element>, hash?: string}) => {
    const { tabs, hash } = params;

    const currentHash = hash || location.hash.replace('#','');

    Array.from(tabs).forEach(tab => { 
        const tabInput = tab.querySelector('input[type="radio"]') as HTMLInputElement;
        if( slugify(tabInput?.id) === currentHash ) {
            tabInput.checked = true;
        }
    });
}
